// import Vue from 'vue'

export const CACHE_NAME_KEY_VALUE = "ox_kv_v1";

export async function setCachedKeyValue(k, v) {
  try {
    const valueString = JSON.stringify(v);
    const cache = await caches.open(CACHE_NAME_KEY_VALUE);

    // Key in eine "Fake-URL" umwandeln, damit DevTools es anzeigen kann
    const request = new Request(`https://example.com/cache/${k}`);

    await cache.put(request, new Response(valueString));
    console.log('setCachedKeyValue succeeded for ' + k);
  } catch (error) {
    console.error('setCachedKeyValue failed for ' + k + ' error: ', error);
  }
}

export async function getCachedValue(k, cb, defaultVal) {
  const cache = await caches.open(CACHE_NAME_KEY_VALUE);

  // Key in dieselbe "Fake-URL" umwandeln wie beim Speichern
  const request = new Request(`https://example.com/cache/${k}`);

  const response = await cache.match(request);
  if (response) {
    try {
      const data = await response.json();
      cb(data);
    } catch (err) {
      console.error("Error parsing cached response", err);
      cb(null);
    }
  } else {
    if (defaultVal) {
      cb(defaultVal);
    } else {
      cb(null);
    }
  }
}

